import { render, staticRenderFns } from "./BxValue.vue?vue&type=template&id=1ba07856&"
import script from "./BxValue.vue?vue&type=script&lang=js&"
export * from "./BxValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports